import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import axios from 'axios'

import router from './router'
import store from './store/'
import md5 from 'js-md5'
import  Base64  from 'js-base64'
import echarts from "echarts";
import * as mUtils from 'utils/mUtils'
import vuescroll from "vuescroll";//引入vuescroll
import "vuescroll/dist/vuescroll.css";//引入vuescroll样式
import Print from 'vue-print-nb';
Vue.use(vuescroll);//使用
Vue.use(Print);  //注册

import Clipboard from 'clipboard'; 

Vue.prototype.Clipboard=Clipboard;
// import BigNumber from "bignumber.mjs"
// import htmlToPdf from 'utils/htmlToPdf'
// Vue.use(htmlToPdf)
import {
	setCookie,
	getCookie,
	delCookie
} from '@/assets/cookie.js'
Vue.use(ElementUI);
// import VueCropper from 'vue-cropper'

Vue.prototype.$echarts = echarts; //在vue原型上添加echarts


// Vue.use(VueCropper)
Vue.prototype.$Base64 = Base64.Base64;
Vue.prototype.$md5 = md5;
Vue.prototype.$cookieStore = {
	setCookie,
	getCookie,
	delCookie
}
Vue.prototype.$sub = axios.create({
	baseURL: process.env.API_ROOT,
	headers: {
		'Content-Type': 'application/json; charset=UTF-8' ,
		'token':mUtils.getStore("token"),
	},
	transformRequest: [function (data) {
		// console.log(data)
		return JSON.stringify(data)
	}],
	transformResponse: [function (data) {
		//  console.log(data)
		 //com.wuji.erp_api.common.ResultModel@5c3b94e9
		if(data){
		var ret = JSON.parse(data);
		// Do whatever you want to transform the data
		if (ret.code == 1203) {
			localStorage.removeItem('userinfo');
			localStorage.removeItem('menuData');
			router.push('/');
		} else if(ret.code==100){
			router.push('/');
		}
		else {
			return ret;
		}
	}else{
		return ;
	}
		
	}],
})
Vue.filter('priceFilt', function (value) {
	  
if (!value) return '0.00';

        // var value = value.toFixed(3);//提前保留两位小数
       
      var intPart = Number(value) - Number(value)%1; // 获取整数部分
      
        var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断 ？？？
       
        var floatPart = '.00'; // 预定义小数部分
        value = value.toString();//将number类型转为字符串类型，方便操作
        var value2Array = value.split('.');
        if (value2Array.length === 2) { // =2表示数据有小数位
            floatPart = value2Array[1].toString(); // 拿到小数部分
            // console.log( value2Array[1].toString())
            if (floatPart.length === 1) { // 补0,实际上用不着
             
                return  intPartFormat + '.' + floatPart + '0';
            } else  {
            
                return intPartFormat + '.' + floatPart;
            }
        } else {
           
            return  intPartFormat + floatPart;
        }
	})
	
	Vue.filter('priceFiltB', function (value) {
	  
		if (!value) return '0.00';
		
				// var value = value.toFixed(3);//提前保留两位小数
			   
			  var intPart = Number(value) - Number(value)%1; // 获取整数部分
			  
				// var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断 ？？？
			   
				var floatPart = '.00'; // 预定义小数部分
				value = value.toString();//将number类型转为字符串类型，方便操作
				var value2Array = value.split('.');
				if (value2Array.length === 2) { // =2表示数据有小数位
					floatPart = value2Array[1].toString(); // 拿到小数部分
					// console.log( value2Array[1].toString())
					if (floatPart.length === 1) { // 补0,实际上用不着
					 
						return  intPart + '.' + floatPart + '0';
					} else  {
					
						return intPart + '.' + floatPart;
					}
				} else {
				   
					return  intPart + floatPart;
				}
			})


Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {


		next()
	//}

})

// router.beforeEach((to, from, next) => {
// 		 console.log(to)
// 		 console.log(from)
// 		 console.log(next)
// 	  if(to.meta.content){
	
// 	    let head = document.getElementsByTagName('head');
	
// 	    let meta = document.createElement('meta');
	           
// 	    meta.content = to.meta.content;
	
// 	    meta.name = "viewport";
// 		console.log(meta)
// 		console.log(head)
// 	    head[0].appendChild(meta)
	
// 	  }
	
// 	  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
	
// 	    if (store.state.InvestorInfo) {  // 通过vuex state获取当前的token是否存在
	               
// 	      next();
	
// 	    }
	
// 	    else {
	
// 	//       next({
	
// 	//         path: '/login',
	
// 	//        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
	
// 	//       })
	
// 	    }
	
// 	  }
	
// 	  else {
	
// 	    next();
	
// 	  }
	
// 	})



new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: {
		App
	}
})


// WEBPACK FOOTER //
// ./src/main.js